interface Props {
  eyebrow: string;
  title: string;
  sub?: string;
  center?: boolean;
}

export default function SectionHeading({ eyebrow, title, sub, center = false }: Props) {
  return (
    <div className={center ? 'text-center mx-auto max-w-3xl' : 'max-w-2xl'}>
      <p className="text-xs md:text-[13px] font-medium tracking-[0.14em] text-secondary-500 mb-4">{eyebrow}</p>
      <h2 data-reveal="heading" className="font-heading text-[32px] md:text-[44px] lg:text-[52px] leading-[1.12] font-medium text-foreground-950 tracking-tight">{title}</h2>
      {sub && <p className="mt-5 text-base md:text-lg leading-[1.6] text-foreground-600">{sub}</p>}
    </div>
  );
}